<template>
  <BaseForm class="edit-event-form border-top pt-32 my-24" v-bind="forward" @submit="onSubmit">
    <EventFormFields v-model="model" :is-editing="true" />
    <template #footer><slot name="footer" /></template>
    <template #actions><slot name="actions" /></template>
  </BaseForm>
</template>

<script>
import EventFormFields from '@/components/forms/EventFormFields';
import objectForm from '@/mixins/objectForm';
import JobEvent from '@/models/JobEvent';

export default {
  name: 'EditEventForm',
  mixins: [objectForm(JobEvent)],
  components: { EventFormFields },
  props: {
    verb: {
      type: String,
      default: 'Save Event',
    },
  },
  computed: {
    /**
     * @returns {boolean}
     */
    showApprovalNote() {
      switch (this.$route?.name) {
        case 'findHelpSearch':
        case 'search':
        case 'searchResults':
          return false;
      }
      return true;
    },
  },
  methods: {
    /**
     * @returns {Promise<void>}
     */
    async onSubmit() {
      this.clearMessages();
      /** @type {JobEvent} */
      const event = await this.action('events/updateEvent', this.model);
      this.successMessage = 'Event updated.';
      this.save(event);
    },
  },
};
</script>
